var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24.765,
    cy: 24.765,
    r: 24.765,
    fill: "#CB202D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.3852 30.4795H30.4802V22.1452L24.7652 25.717L19.0502 22.1452V30.4795H17.1452V19.0495H18.2882L24.7652 23.0977L31.2422 19.0495H32.3852V30.4795ZM32.3852 17.1445H17.1452C16.088 17.1445 15.2402 17.9923 15.2402 19.0495V30.4795C15.2402 30.9848 15.4409 31.4693 15.7982 31.8266C16.1555 32.1838 16.64 32.3845 17.1452 32.3845H32.3852C32.8905 32.3845 33.375 32.1838 33.7323 31.8266C34.0895 31.4693 34.2902 30.9848 34.2902 30.4795V19.0495C34.2902 18.5443 34.0895 18.0597 33.7323 17.7025C33.375 17.3452 32.8905 17.1445 32.3852 17.1445Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.1ec02ccab5e7a982b7afacc58985173b.svg";
export { ForwardRef as ReactComponent };